// extracted by mini-css-extract-plugin
export default {"cls1":"VeloPasswordField-Icon_cls1__r91NO","cls2":"VeloPasswordField-Icon_cls2__g2nvR VeloPasswordField-Icon_cls1__r91NO"};